import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

import pending from "../../../../assets/images/pending 2.png";
import approved from "../../../../assets/images/approved.png";
import completed from "../../../../assets/images/rightSign.png";
import rejected from "../../../../assets/images/Icon/Rejected.png";
import AllDataHeader from "../../../Reuseable/AllDataHeader";
import AllModuleData from "../../../Reuseable/AllModuleData";
import LoaderPost from "../../../Reuseable/LoaderPost";

const StarMeetUpEventList = () => {
  const params = useParams();
  const [event_data, setEvents] = useState([]);
  const [count, setCount] = useState(0);
  const [img, setImg] = useState("");
  const [buffer, setBuffer] = useState(true);

  const imageSuffle = (type) => {
    if (type === "pending") setImg(pending);
    if (type === "approved") setImg(approved);
    if (type === "completed") setImg(completed);
    if (type === "rejected") setImg(rejected);
  };

  // Fetch Stars Added By Admin
  useEffect(() => {
    axios.get(`/api/star/meetup_event/${params.type}`).then((res) => {
      setBuffer(false);
      if (res.status === 200) {
        setEvents(res.data.events);
        setCount(res.data.count);
      }
    });
    imageSuffle(params.type);
  }, [params.type]);

  return (
    <>
      <AllDataHeader
        title={params.type + "  Meetup Events"}
        image={img}
        count={count}
      />

      {buffer ? (
        <LoaderPost />
      ) : (
        <AllModuleData
          data={event_data}
          urlLink={`/superstar/meetup-events/details`}
        />
      )}
    </>
  );
};

export default StarMeetUpEventList;
